/* Copyright 2023 (Unpublished) Verto Inc. */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { CurrentUserService } from '../../services/root-services/current-user.service';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loginForm: UntypedFormGroup;
  invalid = false;
  loading = false;
  redirectUrl: string;

  faChevronRight = faChevronRight;

  constructor(
    private router: Router,
    private currentUserService: CurrentUserService,
    private fb: UntypedFormBuilder,
    private oAuthService: OAuthService,
    private route: ActivatedRoute
  ) {
    this.loginForm = fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(5)]],
    });
  }

  ngOnInit(): void {
    if (this.currentUserService.token) {
      this.router.navigate(['/executions']);
    }
    this.route.queryParams.subscribe((params) => {
      this.redirectUrl = params.redirect;
    });
  }

  login(): void {
    if (this.loginForm.valid) {
      this.invalid = false;
      this.loading = true;
      this.currentUserService
        .login(this.loginForm.value.email, this.loginForm.value.password)
        .subscribe(
          (success) => {
            this.loading = false;
            if (success) {
              if (this.redirectUrl) {
                this.router.navigateByUrl(this.redirectUrl);
              } else {
                this.router.navigate(['executions']);
              }
            } else {
              this.invalid = true;
            }
          },
          () => {
            this.invalid = true;
            this.loading = false;
          }
        );
    } else {
      this.invalid = true;
    }
  }

  signInWithFlow(): void {
    this.oAuthService.loadDiscoveryDocument().then(() => {
      this.oAuthService.initCodeFlow(this.redirectUrl || undefined);
    });
  }
}
